import m from "../../../../geodata/es2015/region/world/southAmericaUltra";
window.am4geodata_region_world_southAmericaUltra = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/world/southAmericaUltra.js
// module id = null
// module chunks = 